import * as yup from 'yup';

export const Tipo_identificacionColumnList = (isAdmin) => {
    return [
        {
       id: 'tipo_identificacion_id',
       dbname: 'id',
       label: 'id',
       visible: false,
       form: false,
       filter: true,
       align: 'right',
       type: 'number',
    },
    {
       id: 'tipo_identificacion_nombre',
       dbname: 'nombre',
       label: 'nombre',
       visible: true,
       form: true,
       filter: true,
       type: 'string',
    },
    {
       id: 'tipo_identificacion_descripcion',
       dbname: 'descripcion',
       label: 'descripcion',
       visible: true,
       form: true,
       filter: true,
       type: 'string',
    },

    ];
};

export const Tipo_identificacionValidationSchema = (t) => {
    return yup.object().shape({
              id: yup.number().nullable(),
      nombre: yup.string().nullable(),
      descripcion: yup.string().nullable(),

    });
};

export const Tipo_identificacionFilterValidationSchema = (t) => {
    return yup.object().shape({
              id: yup.number().nullable(),
      nombre: yup.string().nullable(),
      descripcion: yup.string().nullable(),

    });
};